import { useContext, useEffect } from 'react';

import type { PageSkill } from '../types';
import { ChatbotStoreContext } from '../stores/useChatbot';

/** Memoize the skill object. Pass null while unavailable. Does nothing without a ChatbotProvider. */
export const useRegisterPageSkill = (skill: PageSkill | null) => {
  const store = useContext(ChatbotStoreContext);

  useEffect(() => {
    if (skill && store) return store.getState().registerPageSkill(skill);
  }, [store, skill]);
};
